import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from "lucide-react";
import { API } from "@/App";
import { useLanguage } from "@/LanguageContext";

export const Footer = () => {
  const [settings, setSettings] = useState(null);
  const { t } = useLanguage();

  useEffect(() => {
    axios.get(`${API}/settings`).then((res) => setSettings(res.data)).catch(() => {});
  }, []);

  const phone = settings?.phone || "+4748915190";
  const email = settings?.email || "post@masalaindisk.no";
  const address = settings?.address || "Rikard Kaarbøs plass 1, 9405 Harstad";
  const facebookUrl = settings?.facebook_url || "https://facebook.com/masalaindisk";
  const instagramUrl = settings?.instagram_url || "https://instagram.com/masalaindisk";
  const tripadvisorUrl = settings?.tripadvisor_url || "";
  const hours = settings?.opening_hours || {
    monday_thursday: "15:00 - 22:00",
    friday_saturday: "15:00 - 23:00",
    sunday: "15:00 - 22:00",
  };

  return (
    <footer className="mandala-pattern" style={{ background: 'linear-gradient(135deg, #721111 0%, #2d1810 100%)', borderTop: '4px solid #d4af37' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-4xl font-script mb-4" style={{ color: '#d4af37' }}>Masala Indisk</h3>
            <p className="text-sm leading-relaxed mb-4" style={{ color: '#f5e6d3' }}>{t("footer_desc")}</p>
            <div className="flex gap-3 mt-6">
              <a href={facebookUrl} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: '#2d1810', border: '2px solid #d4af37' }} aria-label="Facebook" data-testid="facebook-link">
                <Facebook className="h-5 w-5" style={{ color: '#d4af37' }} />
              </a>
              <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: '#2d1810', border: '2px solid #d4af37' }} aria-label="Instagram" data-testid="instagram-link">
                <Instagram className="h-5 w-5" style={{ color: '#d4af37' }} />
              </a>
              {tripadvisorUrl && (
                <a href={tripadvisorUrl} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full flex items-center justify-center text-xs font-bold" style={{ background: '#2d1810', border: '2px solid #d4af37', color: '#d4af37' }} aria-label="TripAdvisor" data-testid="tripadvisor-link">TA</a>
              )}
            </div>
          </div>
          <div>
            <h4 className="font-serif-display font-semibold text-lg mb-4" style={{ color: '#d4af37' }}>{t("footer_hours")}</h4>
            <div className="space-y-2 text-sm" style={{ color: '#f5e6d3' }}>
              <div className="flex items-start gap-2">
                <Clock className="h-4 w-4 mt-0.5 flex-shrink-0" style={{ color: '#d4af37' }} />
                <div>
                  <p>{t("hours_mon_thu").split(": ")[0]}: {hours.monday_thursday}</p>
                  <p>{t("hours_fri_sat").split(": ")[0]}: {hours.friday_saturday}</p>
                  <p>{t("hours_sun").split(": ")[0]}: {hours.sunday}</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-serif-display font-semibold text-lg mb-4" style={{ color: '#d4af37' }}>{t("footer_contact")}</h4>
            <ul className="space-y-3 text-sm" style={{ color: '#f5e6d3' }}>
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 flex-shrink-0" style={{ color: '#d4af37' }} /><a href={`tel:${phone}`} className="hover:underline">{phone}</a></li>
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 flex-shrink-0" style={{ color: '#d4af37' }} /><a href={`mailto:${email}`} className="hover:underline">{email}</a></li>
              <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" style={{ color: '#d4af37' }} /><span>{address}</span></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 text-center text-sm" style={{ borderTop: '1px solid rgba(212, 175, 55, 0.3)', color: '#b27f47' }}>
          <p>&copy; 2026 Masala Indisk Restaurant og Bar. {t("footer_rights")}</p>
          <Link to="/personvern" className="hover:underline mt-2 inline-block" style={{ color: '#d4af37' }}>
            Personvernerklaering
          </Link>
          <span className="mx-2" style={{ color: '#b27f47' }}>|</span>
          <Link to="/mine-rettigheter" className="hover:underline mt-2 inline-block" style={{ color: '#d4af37' }} data-testid="footer-gdpr-link">
            Dine Rettigheter (GDPR)
          </Link>
        </div>
      </div>
    </footer>
  );
};
